import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { BarChart2, Calendar, Layers } from "lucide-react";
import { useState } from "react";
import { useBillSummary } from "../../hooks";
import { BillCycleTable } from "../BillCycleTable";
import { useNavigate } from "react-router-dom";
import { Button } from "@shared/ui/button";

const Landing = () => {
  const { data: summary } = useBillSummary();
  const navigate = useNavigate();

  // KPI Cards configuration using QuickStatsCard
  const billCycleKpiCards = [
     {
      title: "Consumer Coverage",
      count: summary?.consumerCoverage || 0,
      trendSummary: `${
        summary?.consumerCoverage || 0
      }% of total configured cycles`,
      trendDirection: "up" as const,
      icon: <Calendar className="h-8 w-8 text-green-500" />,
    },
    {
      title: "Premise Coverage",
      count: summary?.premiseCoverage || 0,
      trendSummary: `${
        summary?.premiseCoveragePercentage || 0
      }% of total configured cycles`,
      trendDirection: "up" as const,
      icon: <Calendar className="h-8 w-8 text-green-500" />,
    },
    {
      title: "Meter Coverage",
      count: summary?.meterCoverage || 0,
      trendSummary: "Average number of times a bill cycle is run",
      trendDirection: "up" as const,
      icon: <BarChart2 className="h-8 w-8 text-amber-500" />,
    },
    {
      title: "Total Bills Generated",
      count: summary?.totalBillCount || 0,
      trendSummary: `${summary?.monthlyCycleGrowth || 0} growth this month`,
      trendDirection:
        summary?.monthlyCycleGrowth && summary.monthlyCycleGrowth > 0
          ? "up"
          : ("down" as const),
      icon: <Layers className="h-8 w-8 text-purple-500" />,
    },
  ];

  const [hasCycles, setHasCycles] = useState(true);

  // Toggle between having data and empty state for demo
  const toggleDataState = () => {
    setHasCycles(!hasCycles);
  };

  return (
    <div className="">
      <div className="flex justify-between items-center">
        <div className="flex flex-col">
          <h2 className="page-title">Bill Cycle</h2>
          <p className="page-subtitle">
            Configure and manage billing cycles to ensure timely and accurate
            bill generation.
          </p>
        </div>
        <Button onClick={() => navigate("action/add")}>
          Create New Bill Cycle
        </Button>
      </div>
      <div className="pt-4">
        {/* KPI Summary Cards - Using loop with QuickStatsCard */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4 pb-4">
          {billCycleKpiCards.map((card, index) => (
            <QuickStatsCard
              key={index}
              title={card.title}
              count={card.count}
              trendSummary={card.trendSummary}
              icon={card.icon}
              trendDirection={"up"}
            />
          ))}
        </div>

        {/* For demo purposes: toggle between data view and empty state */}
        <div className="mb-4 flex justify-end">
          <button
            onClick={toggleDataState}
            className="text-sm text-blue-600"
          ></button>
        </div>

        {/* Bill Cycle Table or Empty State */}
        {<BillCycleTable />}
      </div>
    </div>
  );
};

export default Landing;
